import React from 'react'
import { graphql } from 'gatsby'

// Components
import AboutPage from './AboutPage'

const AboutIndex = (props) => {
  // console.log('👾 AboutIndex > ', props)
  return <AboutPage {...props} />
}

export default AboutIndex

export const aboutQuery = graphql`
  query {
    ...SiteConfig
    prismicAbout {
      data {
        hero {
          title
          image {
            alt
            url
            gatsbyImageData(imgixParams: { auto: "format, compress" })
          }
          content
        }
        cards {
          title
          content {
            raw
            text
          }
        }
      }
    }
  }
`
